import { defineMessages } from "react-intl";

const messages = defineMessages({
  category: {
    defaultMessage: "Category"
  },
  collection: {
    defaultMessage: "Collection"
  },
  collectionPublished: {
    defaultMessage: "Published",
    description: "collection"
  },
  collectionUnpublished: {
    defaultMessage: "Not Published",
    description: "collection"
  },
  createCategory: {
    defaultMessage: "Create Category",
    description: "button"
  },
  createCollection: {
    defaultMessage: "Create Collection",
    description: "button"
  },
  createCustomer: {
    defaultMessage: "Create Customer",
    description: "button"
  },
  createOrder: {
    defaultMessage: "Create Order",
    description: "button"
  },
  createPermissionGroup: {
    defaultMessage: "Create Permission Group",
    description: "button"
  },
  createProduct: {
    defaultMessage: "Create Product",
    description: "button"
  },
  createVoucher: {
    defaultMessage: "Create Coupon Code",
    description: "button"
  },
  customerWithName: {
    defaultMessage: "{firstName} {lastName}"
  },
  goToOrder: {
    defaultMessage: "Go to order #{orderNumber}",
    description: "navigator action"
  },
  helpCatalogMode: {
    defaultMessage: "Search in Catalog",
    description: "navigator catalog mode description"
  },
  helpCommandsMode: {
    defaultMessage: "Search Command",
    description: "navigator command mode description"
  },
  helpCustomersMode: {
    defaultMessage: "Search Customers",
    description: "navigator customer mode description"
  },
  helpDefaultMode: {
    defaultMessage: "Search Views and Actions",
    description: "navigator default mode description"
  },
  helpMode: {
    defaultMessage: "Display Help",
    description: "navigator help mode description"
  },
  helpOrdersMode: {
    defaultMessage: "Search Orders",
    description: "navigator order mode description"
  },
  noResults: {
    defaultMessage: "No Results"
  },
  product: {
    defaultMessage: "Product"
  }
});

export default messages;
